import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="text-xs uppercase tracking-[0.3em] text-white/70 mb-3">404</p>
      <h1 className="font-display text-display-sm md:text-display-md mb-4">Page Not Found</h1>
      <p className="text-white/70 max-w-md mb-8">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" data-testid="not-found-home-link" className="bg-white text-black px-6 py-3 text-sm uppercase tracking-wide hover:bg-white/80 transition-colors duration-200">
        Back to Home
      </Link>
    </div>
  );
}
